import type { Idioma } from "./IdiomaProvider";

const pt = [
  "Monitor TEF",
  "Acompanhe pagamentos, comprovantes e pendências do e-SiTef sem expor dados de cartão.",
  "Portal de cancelamento",
  "Cancelamentos de pagamentos já confirmados são feitos no portal seguro da Software Express. Depois, use Consultar para reconciliar o ERP.",
  "Todos os status",
  "Processando",
  "Confirmado",
  "Negado",
  "Divergente",
  "Cancelado",
  "Buscar por venda, NSU ou autorização...",
  "Atualizar lista",
  "Consultar pagamento",
  "Comprovantes",
  "Desfazer transação pendente",
  "Desfazer esta transação TEF pendente?",
  "Situação TEF atualizada.",
  "Transação pendente desfeita.",
  "Não foi possível carregar as transações TEF.",
  "Não foi possível consultar o TEF.",
  "Não foi possível desfazer a transação.",
  "Comprovante ainda não disponível.",
  "Nenhuma transação TEF encontrada",
  "As transações do caixa aparecerão aqui.",
  "Modalidade",
  "Autorização",
  "Cartão",
  "Comprovantes TEF",
  "Vias retornadas pelo ambiente seguro do provedor.",
  "Via do cliente",
  "Via do estabelecimento",
  "Comprovante não disponível.",
  "Monitor Fiscal",
  "Acompanhe NF-e, NFC-e e NFS-e, consulte retornos e execute eventos fiscais.",
  "Inutilizar numeração",
  "Na fila",
  "Autorizado",
  "Rejeitado",
  "Contingência",
  "Todos os documentos",
  "Documento",
  "Buscar por venda, número ou referência...",
  "Situação fiscal atualizada.",
  "Não foi possível carregar os documentos fiscais.",
  "Não foi possível consultar o documento.",
  "Não foi possível concluir a operação fiscal.",
  "Cancelamento fiscal solicitado.",
  "Carta de correção autorizada.",
  "Numeração inutilizada.",
  "Número / Série",
  "Referência",
  "Retorno",
  "Nenhum documento fiscal encontrado",
  "Os documentos emitidos pelo ERP aparecerão aqui.",
  "Consultar documento",
  "Abrir DANFE",
  "Baixar XML",
  "Cancelar documento",
  "Carta de correção",
  "Cancelar documento fiscal",
  "Informe somente dados permitidos pela legislação fiscal.",
  "Informe uma justificativa com pelo menos 15 caracteres.",
  "Evento fiscal",
  "Correção",
  "Confirmar",
  "Registre a faixa não utilizada diretamente na SEFAZ pela Focus NFe.",
  "Faixa fiscal",
  "Série",
  "Número inicial",
  "Número final",
  "Configurações do PDV",
  "Configure terminais, impressão, ambiente seguro de cancelamento e regras fiscais por empresa.",
  "Novo terminal",
  "Nova regra fiscal",
  "Segredos do e-SiTef são criptografados no servidor e nunca são devolvidos ao navegador. Deixe os campos secretos vazios para manter os valores atuais.",
  "Terminais PDV",
  "Regras fiscais",
  "Credenciais e-SiTef",
  "Impressora",
  "Pin pad",
  "Nenhum terminal configurado",
  "Cadastre cada caixa físico que utiliza o e-SiTef.",
  "Nenhuma regra fiscal configurada",
  "Cadastre regras por documento, UF e regime tributário.",
  "Terminal PDV salvo.",
  "Regra fiscal salva.",
  "Não foi possível carregar as configurações do PDV.",
  "Não foi possível salvar o terminal.",
  "Não foi possível salvar a regra fiscal.",
  "Editar terminal PDV",
  "Novo terminal PDV",
  "As credenciais são enviadas somente ao servidor e armazenadas com criptografia.",
  "Portal de cancelamento",
  "Company code",
  "Terminal ID",
  "Editar regra fiscal",
  "A regra de menor prioridade aplicável será usada na emissão.",
  "Regra fiscal",
  "Natureza da operação",
  "UF destino",
  "Regime tributário",
  "Prioridade",
  "Conferência de caixa",
  "Informe o valor contado em cada forma de pagamento antes do fechamento.",
  "Valores conferidos",
  "Esperado",
  "Diferença",
  "Obrigatória quando houver divergência",
  "Total informado",
  "Salvar conferência",
  "Aprovar divergência",
  "Conferência enviada para aprovação.",
  "Conferência concluída.",
  "Divergência aprovada.",
  "Não foi possível carregar a conferência.",
  "Não foi possível salvar a conferência.",
  "Não foi possível aprovar a conferência.",
  "Monitor de pagamentos eletrônicos e pendências do provedor.",
  "Monitor de documentos, contingência e eventos fiscais.",
  "Terminais, impressão e regras fiscais do ponto de venda.",
] as const;

const en: Partial<Record<(typeof pt)[number], string>> = {
  "Monitor TEF": "EFT Monitor",
  "Acompanhe pagamentos, comprovantes e pendências do e-SiTef sem expor dados de cartão.": "Track e-SiTef payments, receipts and pending items without exposing card data.",
  "Portal de cancelamento": "Cancellation portal",
  "Cancelamentos de pagamentos já confirmados são feitos no portal seguro da Software Express. Depois, use Consultar para reconciliar o ERP.": "Cancel confirmed payments in Software Express's secure portal, then use Check to reconcile the ERP.",
  "Todos os status": "All statuses",
  "Processando": "Processing",
  "Confirmado": "Confirmed",
  "Negado": "Declined",
  "Divergente": "Divergent",
  "Cancelado": "Cancelled",
  "Buscar por venda, NSU ou autorização...": "Search by sale, NSU or authorization...",
  "Atualizar lista": "Refresh list",
  "Consultar pagamento": "Check payment",
  "Comprovantes": "Receipts",
  "Desfazer transação pendente": "Undo pending transaction",
  "Desfazer esta transação TEF pendente?": "Undo this pending EFT transaction?",
  "Situação TEF atualizada.": "EFT status updated.",
  "Transação pendente desfeita.": "Pending transaction undone.",
  "Nenhuma transação TEF encontrada": "No EFT transactions found",
  "As transações do caixa aparecerão aqui.": "Register transactions will appear here.",
  "Modalidade": "Method",
  "Autorização": "Authorization",
  "Cartão": "Card",
  "Comprovantes TEF": "EFT receipts",
  "Vias retornadas pelo ambiente seguro do provedor.": "Copies returned by the provider's secure environment.",
  "Via do cliente": "Customer copy",
  "Via do estabelecimento": "Merchant copy",
  "Comprovante não disponível.": "Receipt not available.",
  "Monitor Fiscal": "Fiscal Monitor",
  "Acompanhe NF-e, NFC-e e NFS-e, consulte retornos e execute eventos fiscais.": "Track NF-e, NFC-e and NFS-e documents, responses and fiscal events.",
  "Inutilizar numeração": "Void number range",
  "Na fila": "Queued",
  "Autorizado": "Authorized",
  "Rejeitado": "Rejected",
  "Contingência": "Contingency",
  "Todos os documentos": "All documents",
  "Documento": "Document",
  "Buscar por venda, número ou referência...": "Search by sale, number or reference...",
  "Situação fiscal atualizada.": "Fiscal status updated.",
  "Nenhum documento fiscal encontrado": "No fiscal documents found",
  "Os documentos emitidos pelo ERP aparecerão aqui.": "Documents issued by the ERP will appear here.",
  "Consultar documento": "Check document",
  "Abrir DANFE": "Open DANFE",
  "Baixar XML": "Download XML",
  "Cancelar documento": "Cancel document",
  "Carta de correção": "Correction letter",
  "Cancelar documento fiscal": "Cancel fiscal document",
  "Confirmar": "Confirm",
  "Configurações do PDV": "POS Settings",
  "Novo terminal": "New terminal",
  "Nova regra fiscal": "New fiscal rule",
  "Terminais PDV": "POS terminals",
  "Regras fiscais": "Fiscal rules",
  "Impressora": "Printer",
  "Nenhum terminal configurado": "No terminal configured",
  "Nenhuma regra fiscal configurada": "No fiscal rule configured",
  "Natureza da operação": "Transaction nature",
  "UF destino": "Destination state",
  "Regime tributário": "Tax regime",
  "Prioridade": "Priority",
  "Conferência de caixa": "Register reconciliation",
  "Valores conferidos": "Counted values",
  "Esperado": "Expected",
  "Diferença": "Difference",
  "Total informado": "Reported total",
  "Salvar conferência": "Save reconciliation",
  "Aprovar divergência": "Approve discrepancy",
};

const es: Partial<Record<(typeof pt)[number], string>> = {
  "Monitor TEF": "Monitor TEF",
  "Acompanhe pagamentos, comprovantes e pendências do e-SiTef sem expor dados de cartão.": "Acompañe pagos, comprobantes y pendientes de e-SiTef sin exponer datos de tarjeta.",
  "Portal de cancelamento": "Portal de cancelación",
  "Todos os status": "Todos los estados",
  "Processando": "Procesando",
  "Confirmado": "Confirmado",
  "Negado": "Rechazado",
  "Divergente": "Divergente",
  "Cancelado": "Cancelado",
  "Atualizar lista": "Actualizar lista",
  "Consultar pagamento": "Consultar pago",
  "Comprovantes": "Comprobantes",
  "Desfazer transação pendente": "Deshacer transacción pendiente",
  "Nenhuma transação TEF encontrada": "No se encontraron transacciones TEF",
  "Modalidade": "Modalidad",
  "Autorização": "Autorización",
  "Cartão": "Tarjeta",
  "Comprovantes TEF": "Comprobantes TEF",
  "Via do cliente": "Copia del cliente",
  "Via do estabelecimento": "Copia del comercio",
  "Monitor Fiscal": "Monitor Fiscal",
  "Inutilizar numeração": "Inutilizar numeración",
  "Na fila": "En cola",
  "Autorizado": "Autorizado",
  "Rejeitado": "Rechazado",
  "Contingência": "Contingencia",
  "Todos os documentos": "Todos los documentos",
  "Documento": "Documento",
  "Consultar documento": "Consultar documento",
  "Abrir DANFE": "Abrir DANFE",
  "Baixar XML": "Descargar XML",
  "Cancelar documento": "Cancelar documento",
  "Carta de correção": "Carta de corrección",
  "Confirmar": "Confirmar",
  "Configurações do PDV": "Configuración del PDV",
  "Novo terminal": "Nuevo terminal",
  "Nova regra fiscal": "Nueva regla fiscal",
  "Terminais PDV": "Terminales PDV",
  "Regras fiscais": "Reglas fiscales",
  "Impressora": "Impresora",
  "Natureza da operação": "Naturaleza de la operación",
  "UF destino": "Estado de destino",
  "Regime tributário": "Régimen tributario",
  "Prioridade": "Prioridad",
  "Conferência de caixa": "Arqueo de caja",
  "Valores conferidos": "Valores contados",
  "Esperado": "Esperado",
  "Diferença": "Diferencia",
  "Total informado": "Total informado",
  "Salvar conferência": "Guardar arqueo",
  "Aprovar divergência": "Aprobar diferencia",
};

const zh: Partial<Record<(typeof pt)[number], string>> = {
  "Monitor TEF": "电子支付监控",
  "Portal de cancelamento": "取消门户",
  "Todos os status": "所有状态",
  "Processando": "处理中",
  "Confirmado": "已确认",
  "Negado": "已拒绝",
  "Divergente": "存在差异",
  "Cancelado": "已取消",
  "Atualizar lista": "刷新列表",
  "Consultar pagamento": "查询支付",
  "Comprovantes": "凭证",
  "Desfazer transação pendente": "撤销待处理交易",
  "Nenhuma transação TEF encontrada": "未找到电子支付交易",
  "Modalidade": "方式",
  "Autorização": "授权码",
  "Cartão": "银行卡",
  "Comprovantes TEF": "电子支付凭证",
  "Via do cliente": "客户联",
  "Via do estabelecimento": "商户联",
  "Monitor Fiscal": "税务监控",
  "Inutilizar numeração": "作废号码段",
  "Na fila": "排队中",
  "Autorizado": "已授权",
  "Rejeitado": "已拒绝",
  "Contingência": "应急模式",
  "Todos os documentos": "所有单据",
  "Documento": "单据",
  "Consultar documento": "查询单据",
  "Abrir DANFE": "打开 DANFE",
  "Baixar XML": "下载 XML",
  "Cancelar documento": "取消单据",
  "Carta de correção": "更正函",
  "Confirmar": "确认",
  "Configurações do PDV": "POS 设置",
  "Novo terminal": "新建终端",
  "Nova regra fiscal": "新建税务规则",
  "Terminais PDV": "POS 终端",
  "Regras fiscais": "税务规则",
  "Impressora": "打印机",
  "Natureza da operação": "业务性质",
  "UF destino": "目的州",
  "Regime tributário": "税制",
  "Prioridade": "优先级",
  "Conferência de caixa": "收银核对",
  "Valores conferidos": "盘点金额",
  "Esperado": "应有",
  "Diferença": "差额",
  "Total informado": "申报总额",
  "Salvar conferência": "保存核对",
  "Aprovar divergência": "批准差异",
};

function montar(sobrescritas: Partial<Record<(typeof pt)[number], string>>): Record<string, string> {
  return Object.fromEntries(pt.map((chave) => [chave, sobrescritas[chave] || chave]));
}

export const TEXTOS_MONITOR_TEF_FISCAL: Record<Idioma, Record<string, string>> = {
  pt: montar({}),
  en: montar(en),
  es: montar(es),
  "zh-CN": montar(zh),
};
